export const environment = {
  production: true,
  logger: { //logger.service
    enabled: false,
    level: 'error', //Possible values: 'debug' > 'info' > 'warning' > 'error'
  },
  userPreferences: {
    alwaysAutoexpandNodes: false, // when cloning nodes always autoexpand cloned node including if original node not expanded
    autoexpandNodesOnCloning: false, // when cloning nodes autoexpand cloned nodes only if original node is expanded 
  },
  apiUrl: 'https://eudravigilance-xevmpd.ema.europa.eu',
  eudravigilanceUrl: 'https://eudravigilance-human.ema.europa.eu/#/',
  clientId: '8739020a-8d79-4db3-a4b7-2a65ad7ac2e9',
  authority: 'https://login.microsoftonline.com/bc9dc15c-61bc-4f03-b60b-e5b6d8922839',
  redirectUri: 'https://eudravigilance-xevmpd.ema.europa.eu',
  serviceDeskURL: 'https://support.ema.europa.eu',
  scope: '8739020a-8d79-4db3-a4b7-2a65ad7ac2e9',
  frontendVersion: 'PROD',
  emaOrganisations: ["EVHUMAN", "EVHUMANWT"],
  maxNumberRowsReturned: 50,
  lookupDebounceMs: 300,
  name: 'production',
  successElapsedTime: 4000,
  warningElapsedTime: 5000,
  errorElapsedTime: 5000,
  inactivityTime: 1800000, //30 minutes
  inactivityWarningTime: 1500000, //25 minutes
  maxZipFileByteSizeEvpost: 62914560,
  maxCumulativeByteSize: 62914560, // 60 MB
  maxIndividualByteSize: 26214400 // 25 MB
};
